module.exports = __webpack_public_path__ + "static/media/onur-tahmaz.13fbc8b2.jpg";